import { em } from 'polished'
import styled, { css } from 'styled-components'

export const Cover = styled.div`
  background: ${p => p.theme.colors.catskillWhite};
  display: ${p => (p.isTablet ? 'none' : 'block')};
  height: 100%;
  position: absolute;
  ${p =>
    p.isTablet
      ? css`
          width: 59vw;
          left: 0;
        `
      : css`
          width: 90%;
          right: 0;
        `}

  ${p => p.theme.mq.upMd} {
    display: ${p => (p.isTablet ? 'block' : 'none')};
  }

  ${p => p.theme.mq.upLg} {
    width: 60%;
  }
`

export const Content = styled.div`
  min-height: 0;
  display: flex;
  align-items: center;

  ${p => p.theme.mq.upMd} {
    min-height: ${p => p.theme.blocks.heightMinResultsMd};
  }

  ${p => p.theme.mq.upLg} {
    min-height: ${p => p.theme.blocks.heightMinResultsLg};
  }
`

export const FrameWrapper = styled.div`
  position: relative;
  min-height: ${p => p.theme.blocks.heightMinResults};

  ${p => p.theme.mq.upMd} {
    overflow: hidden;
    width: 59vw;
    margin-left: ${em(-40)};
    padding-left: ${em(40)};
  }

  ${p => p.theme.mq.upLg} {
    width: auto;
    margin-left: 0;
    padding-left: 0;
  }
`

export const IconWrapper = styled.div`
  position: absolute;
  z-index: 4;
  -webkit-backface-visibility: hidden;

  &.fish {
    width: ${em(140)};
    height: ${em(140)};
    top: 0;
    left: 30%;
    transform: translate(-50%, -20%);

    ${p => p.theme.mq.upMd} {
      width: ${em(110)};
      height: ${em(110)};
      transform: translate(0, -30%);
    }

    ${p => p.theme.mq.upLg} {
      width: ${em(130)};
      height: ${em(130)};
      left: 40%;
      transform: translate(0, -40%);
    }
  }

  &.nutrition {
    width: ${em(120)};
    height: ${em(120)};
    bottom: 0;
    left: 5%;
    transform: translate(0, 10%) rotate(30deg);

    ${p => p.theme.mq.upMd} {
      width: ${em(100)};
      height: ${em(100)};
      left: 50%;
      transform: translate(-50%, -50%) rotate(30deg);
    }

    ${p => p.theme.mq.upLg} {
      width: ${em(130)};
      height: ${em(130)};
      left: auto;
      right: 20%;
      transform: translate(-20%, -60%) rotate(30deg);
    }
  }
`
